import script from "./EditTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTags.vue?vue&type=script&setup=true&lang=ts"

import "./EditTags.vue?vue&type=style&index=0&id=12e1f676&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e1f676"]])

export default __exports__